import React from "react";
import { Modal, Button, Row, Col } from "antd";
import { FormInstance } from "antd/lib/form";
import { TTranslate } from "../../../service/locale/TranslationService";
import { TFormAction } from "./FormAction";

const FormComponent = ({ Form, rowData }) => {
  return React.cloneElement(Form, {
    rowData: rowData
  });
};

export interface Props {
  translate: TTranslate;
  title?: string;
  visible: boolean;
  onSubmit?(values?: any): Promise<any>;
  onFinishEditing(values?: any): boolean;
  onCancel?(args?: any): void;
  rowData?: any;
  Form: any;
  formInstance?: FormInstance;
  className: string;
  okText?: string;
  cancelText?: string;
  formActions?: TFormAction[];
}

export interface State {
  loading: boolean;
}

export default class GridEditorModal extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.renderFormAction = this.renderFormAction.bind(this);
    this.renderFooter = this.renderFooter.bind(this);
    this.state = {
      loading: false
    };
  }
  private renderFormAction(action: TFormAction) {
    const onClick = async () => {
      try {
        if (action.key === "cancel") {
          this.props.formInstance?.resetFields();
          this.props.onCancel?.();
        }
        let values =
          action.key === "back"
            ? false
            : await this.props.formInstance?.validateFields();
        const result = await action.onClick(values);

        if (result) {
          this.props.onFinishEditing(values);
          this.props.formInstance?.resetFields();
        }
      } catch (error: any) {
        console.log(error);
      }
    };
    let Component = action.Component || (Button as any);

    return (
      <Component
        disabled={action.disable && action.disable(this.props.rowData)}
        key={action.key}
        onClick={onClick}
        type={action.type}
        record={this.props.rowData}
        {...(action.buttonProps || {})}
      >
        {action.label}
      </Component>
    );
  }

  private renderFooter() {
    const { formActions } = this.props;
    if (formActions == null) {
      return undefined;
    }

    return (
      <Row gutter={8}>
        <Col span={12}>
          {formActions
            .filter((item) => item.position === "left")
            .map(this.renderFormAction)}
        </Col>
        <Col span={12}>
          {formActions
            .filter((item) => item.position !== "left")
            .map(this.renderFormAction)}
        </Col>
      </Row>
    );
  }

  render() {
    const {
      translate,
      title,
      visible,
      onCancel,
      Form,
      formInstance,
      className,
      onSubmit,
      rowData
    } = this.props;
    formInstance?.setFieldsValue(rowData);
    return (
      <Modal
        visible={visible}
        title={title}
        okText={translate("data_grid.modal.actions.save")}
        cancelText={translate("data_grid.modal.actions.cancel")}
        confirmLoading={this.state.loading}
        onCancel={() => {
          formInstance?.resetFields();
          onCancel?.();
        }}
        maskClosable={false}
        onOk={async () => {
          try {
            let val = await formInstance?.validateFields();
            let res = await onSubmit?.(val);
            this.props.formInstance?.resetFields();
            this.props.onFinishEditing(res);
          } catch (err) {
            console.log(err);
          }
        }}
        className={"modal-position " + className}
        footer={this.renderFooter()}
      >
        <FormComponent Form={Form} rowData={rowData} />
      </Modal>
    );
  }
}
